import { Button, ButtonProps, Icon } from '@chakra-ui/react';
import { ColumnFiltersState, Table } from '@tanstack/react-table';
import { snakeCase } from 'lodash';
import { RiFileExcel2Line } from 'react-icons/ri';

import { MetaData, ResourceType } from '../../_openapi/portfolio-optimizer';
import { useDataExport } from '../../api/dataExport';

export const ExportResults = <T,>({
    table,
    resourceType,
    metaData,
    buttonProps,
    columnFilters: columnFiltersOverride,
}: {
    table: Table<T>;
    resourceType: ResourceType;
    metaData?: MetaData;
    buttonProps?: ButtonProps;
    columnFilters?: ColumnFiltersState;
}) => {
    const { mutate, isPending } = useDataExport(resourceType, metaData);

    const exportData = () => {
        const columns = table
            .getAllLeafColumns()
            .filter((column) => !column.columnDef.meta?.isDisplayCol && column.getIsVisible())
            .map((col) => col.id && snakeCase(col.id))
            .filter(Boolean);

        const { sorting, columnFilters } = table.getState();
        mutate({ columns, sorting, columnFilters: columnFiltersOverride ?? columnFilters });
    };

    return (
        <Button
            leftIcon={<Icon as={RiFileExcel2Line} />}
            variant="outline"
            size="sm"
            {...buttonProps}
            onClick={exportData}
            isLoading={isPending}
        >
            Export results
        </Button>
    );
};
